








































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {HealthPropadandaList,ClearResource} from "../../api/healthPropaganda"
import addOrEdit from './addOrEditModal.vue'
import detail from './detail.vue'
@Component({
    components: {addOrEdit,detail}
})
export default class extends AbpBase {
    type = 0
    queryString = ''
    list: Array<object> = []
    formShow: boolean = false
    formTitle: string = ''
    formData: object = {}
    formItem: Array<object> = []
    url = XMLHTTP_BASEURL

    detailShow = false
    detailTile = ''
    detailId = null
    getDetail(item){
        this.detailId = item.id
        this.detailTile = item.title
        this.detailShow = true
    }
    async remove(item){
        this.$confirm('确认删除？')
        .then(async _ => {
            let res = await ClearResource({id:item.id})
            if(res.code==2000){
                this.getData()
            }
        })
        .catch(_ => {});
    }
    created() {
        this.getSelects()
        this.getData()
    }
    //宣教分类
    categoryList:any = [{id:0,typeName:'全部'}]
    async getSelects(){
        this.categoryList.push(...(await this.QuerySysDic({dataType:7,typeName:'',status:true})).data)
    }
    async getData() {
        this.table.loading = true
        let res = await HealthPropadandaList({
            CategoryId:this.type,
            queryString:this.queryString
        })
        this.list = res.data;
        this.table.loading = false
    }

    addOrEdit(row: object) {
        this.formTitle = !row ? '新增' : '编辑'
        this.formData = row
        this.formShow = true
    }
    
}
